import React from 'react';

import IconEmpty from 'icons/icon-empty';

const NoEntries = ({ showIcon = true, center = true, absolute, text, btnCreateCopy, onCreate }) => {
    return (
        <div className={'no-entries' + (center ? ' center' : '') + (absolute ? ' absolute' : '')}>
            <div className="no-entries-content">
                {
                    showIcon ? (
                        <IconEmpty />
                    ) : null
                }

                <div className="no-entries-content-text">{ text }</div>

                {
                    btnCreateCopy && onCreate ? (
                        <button className="btn btn-success" onClick={onCreate}>{ btnCreateCopy }</button>
                    ) : null
                }
            </div>
        </div>
    );
}

export default NoEntries;
